import { getRequestEvent, isServer } from 'solid-js/web';
import { MagicRequest } from './magicRequest';
import { NetworkManager } from './networkManager';

export class BaseNetworkManager implements NetworkManager {
  public sendRequest = async (request: MagicRequest): Promise<Response> => {
    const base = '/tenants';
    return await fetch(this.matchUriWithPrefix(`${base}${request.url}`), {
      method: request.method,
      headers: request.headers,
      body: request.body,
    });
  };

  public matchUriWithPrefix = (uri: string) => {
    if (isServer) {
      const requestEvent = getRequestEvent();
      if (import.meta.env.DEV && requestEvent) return new URL(requestEvent.request.url).origin + uri;
      return `http://portal-backend` + uri.replace(/^\/tenants\/api/, '/tenant-app');
    }
    return uri;
  };
}

export const baseNetworkManager = new BaseNetworkManager();
